/* eslint-disabled */

export default class PropertyValueExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
